// Feature flags for toggling platform features
// Set to true to re-enable the Organisations module across the platform

export const ENABLE_ORGANISATIONS = false;
